import React from "react";
import { useSelector } from "react-redux";

import {
  getChatImageUrl,
  getChatOnlineStatus,
  getChatBusyStatus,
} from "../../../selectors/chat/chat";
import { OnlineStatus } from "./OnlineStatus";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUser, faUsers } from "@fortawesome/pro-solid-svg-icons";

const ICONS = {
  member: faUser,
  group: faUsers,
};

type ImageArgs = {
  type: string;
  imageUrl: string;
  name: string;
};

function Image({ type, imageUrl, name }: ImageArgs) {
  return imageUrl ? (
    <img
      className="chatImage h-10 w-10 rounded-full"
      alt=""
      title={name}
      src={imageUrl}
    />
  ) : (
    <div className="w-10 h-10 flex items-center justify-center bg-white border-neutral border rounded-full">
      <FontAwesomeIcon
        icon={ICONS[type]}
        title={name}
        className="chatIcon text-muted"
        size="xl"
      />
    </div>
  );
}

type ChatImageArgs = {
  name: string;
  chatId: string;
};

export default function ChatImage({ name, chatId }: ChatImageArgs) {
  const imageUrl = useSelector((state) => getChatImageUrl(state, chatId));
  const isOnline = useSelector((state) => getChatOnlineStatus(state, chatId));
  const isBusy = useSelector(
    (state) => getChatBusyStatus(state, chatId)?.type === "busy",
  );
  const type = chatId.split("/")[0];

  return (
    <div className="shrink-0 stack-item">
      <OnlineStatus isOnline={isOnline} isBusy={isBusy}>
        <Image type={type} name={name} imageUrl={imageUrl} />
      </OnlineStatus>
    </div>
  );
}
